// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2HdY1","content":"styles_content__22QEP","selectAll":"styles_selectAll__3rPqE"};